const defaultApiBaseUrl = ["localhost", "127.0.0.1"].includes(
  window.location.hostname
)
  ? "http://localhost:8080"
  : "https://api.oekfb.eu";

// Removing trailing slashes keeps endpoint URL construction consistent.
export const API_BASE_URL = (
  process.env.REACT_APP_API_BASE_URL || defaultApiBaseUrl
).replace(/\/+$/, "");

